import React from 'react';
import { useTranslation } from 'react-i18next';
import { SparklesIcon } from '@hero/web-icons';
import { cn } from '@hero/web-lib';
import { Badge } from '../../../ui/Badge';

export interface OwnRouteBadgeProps {
  isOwnRoute: boolean;
  className?: string;
}

/**
 * Visual kind marker for a Route.
 *
 *   - `isOwnRoute = true`  → "Own rate" pill, amber (catalog / default
 *                            rate that any party can match against).
 *   - `isOwnRoute = false` → "Custom price" pill, violet with a
 *                            sparkles glyph. Reads as "this is a
 *                            tailored, party-specific price" — color
 *                            and icon are intentionally different
 *                            from the sell/buy palette (green/blue),
 *                            which encodes side, not kind.
 */
export function OwnRouteBadge({ isOwnRoute, className }: OwnRouteBadgeProps) {
  const { t } = useTranslation(['m-route']);
  if (isOwnRoute) {
    return (
      <Badge
        variant="outline"
        size="small"
        className={cn('bg-amber-50 text-amber-700 border-transparent', className)}>
        {t('route_kind.own_route.title')}
      </Badge>
    );
  }
  return (
    <Badge
      variant="outline"
      size="small"
      icon={<SparklesIcon className="text-violet-500" />}
      className={cn(
        'bg-violet-50 text-violet-700 border-transparent',
        className,
      )}>
      {t('route_kind.directed.title')}
    </Badge>
  );
}
